import HeroButton from "../Heros/HeroButton";
import HeroDescription from "../Heros/HeroDescription";
import HeroTitle from "../Heros/HeroTitle";
import SectionText from "../Section/SectionText";
import Section2Btn from "./Section2Btn";
import Section2Root from "./Section2Root";

export const Section2 = {
    Root: Section2Root,
    Title: HeroTitle,
    Button: HeroButton,
    Button2: Section2Btn,
    Description: HeroDescription,
    Text: SectionText
}